<template>
    <div>
        <!-- <button type="button" @click="onScan">扫一扫</button> 扫码 -->
    </div>
</template>
  
<script>
import wxServ from "../service/wxServ";
export default {
    data() {
        return {

        }
    },
    created() {
        this.onScan()
    },
    methods: {
        onScan() {
            this.wxConfigJssdk()
        },
        wxConfigJssdk() {
            wxServ.configJssdkScan();
            const that = this;
            wx.ready(function () {
                wx.checkJsApi({
                    jsApiList: ['scanQRCode'],
                    success: function (res1) {
                        if (res1.checkResult.scanQRCode) {
                            // 当scanQRCode可使用时
                            wx.scanQRCode({
                                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                                scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
                                success: function (res2) {
                                    let result = res2.resultStr;
                                    window.location.href = result;
                                },
                                error: function (response) {
                                    alert(response)
                                },
                            });
                        }
                    },
                });
            });
        }
    }
};
</script>
  
<style></style>
  


// WEBPACK FOOTER //
// src/pages/scan.vue